import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "pq_content"
};
import { ElMessage } from 'element-plus';
import { getCurrentInstance, ref, useAttrs, watch } from 'vue';
/* 数据层 */

export default {
  __name: 'lcDailogrybh',
  props: ['ids', 'bhshow', 'msg'],
  emits: ['update:bhshow'],
  setup(__props, {
    emit: __emit
  }) {
    const {
      proxy
    } = getCurrentInstance();
    const props = __props;
    const remark = ref(JSON.parse(JSON.stringify(props.msg)));
    /* 初始化 */
    /* 方法 */
    const emits = __emit;
    const attrs = useAttrs();

    // 确认
    function makeSure() {
      if (props.ids) {
        proxy.$http.showLoading(false).post('project/task/reject', {
          id: props.ids,
          msg: remark.value
        }).then(res => {
          // 刷新爷组件详情数据接口
          if (res.errno == 200) {
            attrs.deppgetPageInfo();
            ElMessage({
              type: 'success',
              message: '操作成功'
            });
          } else {
            ElMessage({
              type: 'error',
              message: res.errmsg
            });
          }
        });
      }
      emits('update:bhshow', false);
    }
    //关闭的点击事件
    function handleClose() {
      emits('update:bhshow', false);
    }
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_dialog, {
        title: "驳回原因",
        "model-value": __props.bhshow,
        width: "500px",
        "before-close": handleClose,
        center: false
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_input, {
          type: "textarea",
          placeholder: "请输入内容",
          modelValue: remark.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => remark.value = $event),
          class: "lc_bz",
          style: {
            "max-height": "300px",
            "margin-bottom": "0 !important"
          }
        }, null, 8, ["modelValue"])]), _createElementVNode("div", {
          class: "pq_content",
          style: {
            "justify-content": "right",
            "margin-top": "15px"
          }
        }, [_createElementVNode("div", {
          class: "l-button pqbt",
          onClick: handleClose
        }, "取消"), _createElementVNode("div", {
          class: "l-button",
          style: {
            "margin-right": "0",
            "margin-left": "15px"
          },
          onClick: makeSure
        }, "确认")])]),
        _: 1
      }, 8, ["model-value"])]);
    };
  }
};